import script from "./Developer.vue?vue&type=script&setup=true&lang=js"
export * from "./Developer.vue?vue&type=script&setup=true&lang=js"

import "./Developer.vue?vue&type=style&index=0&id=93ad5df4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93ad5df4"]])

export default __exports__